import { render, staticRenderFns } from "./ErrorDetail.vue?vue&type=template&id=59bb6277&scoped=true"
import script from "./ErrorDetail.vue?vue&type=script&lang=ts"
export * from "./ErrorDetail.vue?vue&type=script&lang=ts"
import style0 from "./ErrorDetail.vue?vue&type=style&index=0&id=59bb6277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb6277",
  null
  
)

export default component.exports